import { Alert } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import { usePractitionerSettings } from '../../../../lib/practitioner-settings/hooks/usePractitionerSettings'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import CommissionsProgramSection from './practitioner/rewards-program/CommissionsProgramSection'
import PayoutsProgramSection from './practitioner/rewards-program/PayoutsProgramSection'
import RebateProgramSection from './practitioner/rewards-program/RebateProgramSection'
import VipDiscountsSection from './practitioner/rewards-program/VipDiscountsSection'

const Container = styled.div`
  padding-bottom: 12px;
  @media (min-width: 768px) {
    max-width: 688px;
    padding-left: 47px;
    padding-top: 16px;
    padding-bottom: unset;
    h3 {
      max-width: 350px;
    }
  }
`

const StyledHeader = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 24px;
  color: #001b36;
  margin-bottom: 8px;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }
  font-size: 16px;
  color: #001b36;
  margin-bottom: 0;
  line-height: 1.19;
`

const RewardsProgramContainer: React.FC = () => {
  const [settings, { loading: settingsLoading, error: settingsError, called: settingsCalled }] =
    usePractitionerSettings()
  if (!settingsCalled || settingsLoading) {
    return <Spinner loading />
  }
  if (settingsError || !settings) {
    console.error('Error loading practitioner settings', settingsError)
    return (
      <Alert type="error">
        We were unable to load your practitioner settings, please try again soon.
      </Alert>
    )
  }

  return (
    <Container>
      <StyledHeader>Rewards Program</StyledHeader>
      <StyledDescription>
        As a DFH practitioner, you&apos;re automatically enrolled in our innovative customer rewards
        program. Enable the components below and you can start earning generous rewards with your
        first purchase.
      </StyledDescription>
      <Spacer size={4} />
      <RebateProgramSection settings={settings} />
      <Spacer size={4} />
      <CommissionsProgramSection settings={settings} />
      <Spacer size={4} />
      <VipDiscountsSection />
      <Spacer size={4} />
      <PayoutsProgramSection settings={settings} />
    </Container>
  )
}

RewardsProgramContainer.defaultProps = {}

RewardsProgramContainer.propTypes = {}

export default RewardsProgramContainer
